import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconShapeLine';
/** Renders an SVG icon. */
const SvgShapeLine = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path fill="currentColor" d="m24.707 8.707-16 16-1.414-1.414 16-16z" />
      <path fill="currentColor" d="M27 7a2 2 0 1 1-4 0 2 2 0 0 1 4 0M9 25a2 2 0 1 1-4 0 2 2 0 0 1 4 0" />
    </svg>
  );
};
SvgShapeLine.displayName = displayName;
export default SvgShapeLine;
